import React, { useEffect, useState } from "react";
import "./Home.css";
import System from "./components/system";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";
import BrokerComponent from "../Brokers/broker.js";
import InvitationComponent from "../Brokers/invitation.js";
import CilComponent from "../Cils/cils.js";
import FormComponent from "../Forms/forms";
import SliderComponent from "../Sliders/sliders.js";
import AddSlider from "../Sliders/addSlider.js";
import GuidelineComponent from "../Guideline/guidelines";
import AddGuideline from "../Guideline/addGuideline";
import TrainingComponent from "../training/training.js";
import AddTraining from "../training/addTraining.js";
import FranchiseComponent from "../Franchise/franchise.js";
import RequestFranchisesComponent from "../RequestFranchises/requestFranchises.js";
import DealComponent from "../Deals/deals.js";
import MediaBuyingComponent from "../MediaBuyingFree/mediaBuying";
import Logo from "../../assets/logo.png";
import HelpTeamComponent from "../HelpTeam/helpTeam.js";
import AddHelpTeam from "../HelpTeam/addHelpTeam.js";
import ChangePassword from "./components/changePassword";
import FeedbackComponent from "../Feedback/feedbacks.js";
import ForgotPasswordPage from "../ForgotPAssword/ForgotPasswordPage";
import AddFranchise from "../OurFranchise/addOurFranchise.js";
import OurFranchiseComponent from "../OurFranchise/ourFranchise.js";
import NotificationComponent from "../components/notification.js";
import { getAlert } from "../../api/admins.js";
import SeparatesComponent from "../Separates/SeparatesComponent.js";
import InvitationUserComponent from "../Brokers/invitationUsers.js";
import PrimaryProjectsComponent from "../PrimaryProjects/PrimaryProjectsComponent.js";
import AddSeparateComponent from "../Separates/AddSeparate.js";
import AddPrimaryComponent from "../PrimaryProjects/AddPrimary.js";
import ResalesComponent from "../Resale/ResalesComponent.js";
import AddResaleComponent from "../Resale/AddResale.js";

const Dashboard = (props) => {
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [activeTab, setActiveTab] = useState("");
  const [activeSubTab, setActiveSubTab] = useState("");
  const [activeSubSubTab, setActiveSubSubTab] = useState("");

  const tabs = [
    {
      name: "Broker",
      sub_page: [
        {
          title: "Brokers",
          sub: [
            "All Brokers",
            "New Brokers",
            "Banned Brokers",
            "Teams",
            "User invited",
          ],
        },
        {
          title: "CIL",
          sub: ["New CIL", "Pending CIL", "Accept CIL", "Reject CIL"],
        },
        {
          title: "Deals",
          sub: ["New forms", "Pending forms", "Accept forms", "Reject forms"],
        },
        {
          title: "Sliders",
          sub: ["Sliders", "Add slider"],
        },
        {
          title: "Notification",
          sub: [],
        },
        {
          title: "Guidelines",
          sub: ["Guidelines", "Add guideline"],
        },
        {
          title: "Training",
          sub: ["Trainings", "Add training"],
        },
      ],
    },
    {
      name: "Franchise",
      sub_page: [
        {
          title: "Franchises",
          sub: [
            "All Franchises",
            "Banned Franchises",
            "App Franchises",
            "Add Franchise",
          ],
        },
        {
          title: "Join request",
          sub: ["New request", "Accept request", "Reject request"],
        },
        {
          title: "Deals",
          sub: ["New deals", "Pending deals", "Accept deals", "Reject deals"],
        },
        {
          title: "Request media buying",
          sub: ["New Request", "Accept Request", "Reject Request"],
        },
        {
          title: "Notification",
          sub: [],
        },
        {
          title: "Sliders",
          sub: ["Sliders", "Add slider"],
        },
        {
          title: "Guidelines",
          sub: ["Guidelines", "Add guideline"],
        },
      ],
    },
    {
      name: "Projects",
      sub_page: [
        { title: "Primary", sub: ["View Primary", "Add Primary"] },
        { title: "Separate", sub: ["View Separates", "Add Separate"] },
        {
          title: "Resale",
          sub: ["View Resale", "Pending Resale", "Add Resale"],
        },
      ],
    },
    {
      name: "General",
      sub_page: [
        {
          title: "Team",
          sub: ["Team Members", "Add Member"],
        },
        {
          title: "Feedback",
          sub: ["New feedback", "Done feedback"],
        },
        {
          title: "Forgot password",
          sub: [],
        },
        {
          title: "System",
          sub: [],
        },
        {
          title: "Change my password",
          sub: [],
        },
      ],
    },
    {
      name: "CRM",
      sub_page: [],
    },
    {
      name: "Logout",
      sub_page: [],
    },
  ];

  const navigate = useNavigate();

  const [list, setList] = useState(null);

  useEffect(() => {
    console.log(props);
    if (localStorage.getItem("page")) {
      setActiveTab(localStorage.getItem("page"));
    }
    if (localStorage.getItem("subpage")) {
      setActiveSubTab(localStorage.getItem("subpage"));
    }
    if (localStorage.getItem("subsubpage")) {
      setActiveSubSubTab(localStorage.getItem("subsubpage"));
    }
  }, []);

  const fetchAlert = async () => {
    await getAlert().then((result) => {
      setList(result.data.response);
    });
  };

  const changeToView = async (sub) => {
    setActiveSubSubTab(sub);
    localStorage.setItem("subsubpage", sub);
    window.location.reload();
  };

  useEffect(() => {
    if (!list) {
      fetchAlert();
    }
    console.log(list);
  }, [list]);

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <div className={`sidebar`}>
        <div className="sidebar-header">
          <h2>Free Brokers Dashboard</h2>
        </div>
        <div className="tabs">
          {tabs.map((tab, index) => (
            <div key={tab.name} style={{ width: "100%" }}>
              <div>
                <button
                  className={`tab ${activeTab === tab.name && activeSubTab === "" && activeSubSubTab === "" ? "active" : ""}`}
                  style={{ width: "100%" }}
                  onClick={() => {
                    if (tab.name === "Logout") {
                      navigate("/login", { replace: true });
                      localStorage.removeItem("page");
                      localStorage.removeItem("subpage");
                      localStorage.removeItem("subsubpage");
                      cookie.remove("token");
                      cookie.remove("isSuper");
                    } else if (tab.name === "CRM") {
                      window.open("https://crm.freebrokers.online", "_blank");
                    } else {
                      setActiveSubTab("");
                      setActiveSubSubTab("");
                      localStorage.removeItem("subpage");
                      localStorage.removeItem("subsubpage");
                      if (tab.name !== activeTab) {
                        setActiveTab(tab.name);
                        localStorage.setItem("page", tab.name);
                      } else {
                        setActiveTab("");
                        localStorage.removeItem("page");
                      }
                    }
                  }}
                >
                  {tab.name}{" "}
                  {list &&
                    ((tab.name === "Broker" &&
                      (list.cils_new ||
                        list.cils_pending ||
                        list.forms_new ||
                        list.forms_pending ||
                        list.new_user)) ||
                      (tab.name === "Franchise" &&
                        (list.deals_new ||
                          list.deals_pending ||
                          list.join ||
                          list.requestMedia)) ||
                      (tab.name === "General" &&
                        (list.feedback || list.forgetPassword)) ||
                      (tab.name === "Projects" && list.pending_resale))
                    ? " 🔔"
                    : ""}
                </button>
                {tab.name === activeTab && (
                  <>
                    {tab.sub_page.map((page, index) => (
                      <div
                        key={page.title}
                        style={{ width: "100%", paddingLeft: "20px" }}
                      >
                        <div>
                          {(isSuper || page.title !== "System" || page.title !== "Sliders") && (
                            <button
                              className={`tab ${activeSubTab === page.title && activeSubSubTab === "" ? "active" : ""}`}
                              style={{
                                width: "90%",
                                paddingLeft: "20px",
                                color: "darkkhaki",
                              }}
                              onClick={() => {
                                setActiveSubSubTab("");
                                localStorage.removeItem("subsubpage");
                                if (page.title === activeSubTab) {
                                  setActiveSubTab("");
                                  localStorage.removeItem("subpage");
                                } else {
                                  fetchAlert();
                                  setActiveSubTab(page.title);
                                  localStorage.setItem("subpage", page.title);
                                }
                              }}
                            >
                              {page.title}{" "}
                              {list &&
                                ((page.title === "Brokers" && list.new_user) ||
                                  (page.title === "CIL" &&
                                    (list.cils_new || list.cils_pending)) ||
                                  (page.title === "Deals" &&
                                    activeTab === "Broker" &&
                                    (list.forms_new || list.forms_pending)) ||
                                  (page.title === "Deals" &&
                                    activeTab === "Franchise" &&
                                    (list.deals_new || list.deals_pending)) ||
                                  (page.title === "Join request" && list.join) ||
                                  (page.title === "Request media buying" &&
                                    list.requestMedia) ||
                                  (page.title === "Feedback" && list.feedback) ||
                                  (page.title === "Forgot password" &&
                                    list.forgetPassword) ||
                                  (page.title === "Resale" &&
                                    list.pending_resale))
                                ? " 🔔"
                                : ""}
                            </button>
                          )}
                          {page.title === activeSubTab && (
                            <>
                              {page.sub.map((sub, index) => (
                                <div
                                  key={sub}
                                  style={{ width: "100%", paddingLeft: "20px" }}
                                >
                                  <div>
                                    {(isSuper ||
                                      (sub !== "Add guideline" &&
                                        sub !== "Add training" &&
                                        sub !== "Add Member" &&
                                        sub !== "Add Franchise" &&
                                        sub !== "Add slider")) && (
                                        <button
                                          className={`tab ${activeSubSubTab === sub ? "active" : ""}`}
                                          style={{
                                            width: "100%",
                                            paddingLeft: "20px",
                                            color: "aquamarine",
                                          }}
                                          onClick={() => {
                                            if (sub === activeSubSubTab) {
                                              setActiveSubSubTab("");
                                              localStorage.removeItem(
                                                "subsubpage",
                                              );
                                            } else {
                                              fetchAlert();
                                              setActiveSubSubTab(sub);
                                              localStorage.setItem(
                                                "subsubpage",
                                                sub,
                                              );
                                            }
                                          }}
                                        >
                                          {sub}{" "}
                                          {list &&
                                            ((list.new_user &&
                                              sub === "New Brokers") ||
                                              (list.deals_pending &&
                                                sub === "Pending deals") ||
                                              (list.deals_new &&
                                                sub === "New deals") ||
                                              (list.forms_pending &&
                                                sub === "Pending forms") ||
                                              (list.forms_new &&
                                                sub === "New forms") ||
                                              (list.cils_new &&
                                                sub === "New CIL") ||
                                              (list.cils_pending &&
                                                sub === "Pending CIL") ||
                                              (list.join &&
                                                sub === "New request") ||
                                              (list.requestMedia &&
                                                sub === "New Request") ||
                                              (list.forgetPassword &&
                                                sub === "Forgot password") ||
                                              (list.feedback &&
                                                sub === "New feedback") ||
                                              (list.pending_resale &&
                                                sub === "Pending Resale"))
                                            ? " 🔔"
                                            : ""}
                                        </button>
                                      )}
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        <div className="content-header">
          <h1>
            {activeSubSubTab === "" && activeSubTab === "Primary"
              ? activeSubTab !== "Primary"
                ? "FreeBrokers"
                : activeSubTab
              : activeSubSubTab}
          </h1>
        </div>
        <div className={`content-body`}>
          {activeSubTab !== "Notification" &&
            activeSubSubTab === "" &&
            activeSubTab !== "Forgot password" &&
            activeSubTab !== "System" &&
            activeSubTab !== "Change my password" && (
              <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <img src={Logo} alt="Logo" height="400px" />
              </div>
            )}
          {activeSubSubTab === "All Brokers" && (
            <BrokerComponent page="Brokers" />
          )}
          {activeSubSubTab === "New Brokers" && (
            <BrokerComponent page="New Brokers" />
          )}
          {activeSubSubTab === "Banned Brokers" && (
            <BrokerComponent page="Banned Brokers" />
          )}
          {activeSubSubTab === "Teams" && (
            <InvitationComponent userType="Brokers" />
          )}
          {activeSubSubTab === "User invited" && <InvitationUserComponent />}
          {activeSubTab === "Notification" && (
            <NotificationComponent userType={activeTab} />
          )}
          {activeSubSubTab === "New CIL" && <CilComponent cilType={"New"} />}
          {activeSubSubTab === "Pending CIL" && (
            <CilComponent cilType={"Pending"} />
          )}
          {activeSubSubTab === "Accept CIL" && (
            <CilComponent cilType={"Accept"} />
          )}
          {activeSubSubTab === "Reject CIL" && (
            <CilComponent cilType={"Reject"} />
          )}
          {activeSubSubTab === "New forms" && (
            <FormComponent formType={"New"} />
          )}
          {activeSubSubTab === "Pending forms" && (
            <FormComponent formType={"Pending"} />
          )}
          {activeSubSubTab === "Accept forms" && (
            <FormComponent formType={"Accept"} />
          )}
          {activeSubSubTab === "Reject forms" && (
            <FormComponent formType={"Reject"} />
          )}
          {activeSubSubTab === "Sliders" && (
            <SliderComponent user={activeTab} isSuper={isSuper} />
          )}
          {activeSubSubTab === "Add slider" && (
            <AddSlider user={activeTab} isSuper={isSuper} />
          )}
          {activeSubSubTab === "Guidelines" && (
            <GuidelineComponent user={activeTab} isSuper={isSuper} />
          )}
          {activeSubSubTab === "Add guideline" && (
            <AddGuideline user={activeTab} isSuper={isSuper} />
          )}
          {activeSubSubTab === "Trainings" && (
            <TrainingComponent isSuper={isSuper} />
          )}
          {activeSubSubTab === "Add training" && (
            <AddTraining isSuper={isSuper} />
          )}
          {activeSubSubTab === "All Franchises" && (
            <FranchiseComponent page="Franchises" />
          )}
          {activeSubSubTab === "Banned Franchises" && (
            <FranchiseComponent page="Banned Franchises" />
          )}
          {activeSubSubTab === "New request" && (
            <RequestFranchisesComponent page={"new"} />
          )}
          {activeSubSubTab === "Accept request" && (
            <RequestFranchisesComponent page={"accept"} />
          )}
          {activeSubSubTab === "Reject request" && (
            <RequestFranchisesComponent page={"reject"} />
          )}
          {activeSubSubTab === "New deals" && (
            <DealComponent dealType={"New"} />
          )}
          {activeSubSubTab === "Pending deals" && (
            <DealComponent dealType={"Pending"} />
          )}
          {activeSubSubTab === "Accept deals" && (
            <DealComponent dealType={"Accept"} />
          )}
          {activeSubSubTab === "Reject deals" && (
            <DealComponent dealType={"Reject"} />
          )}
          {activeSubSubTab === "New Request" && (
            <MediaBuyingComponent status={"New"} />
          )}
          {activeSubSubTab === "Accept Request" && (
            <MediaBuyingComponent status={"Accept"} />
          )}
          {activeSubSubTab === "Reject Request" && (
            <MediaBuyingComponent status={"Reject"} />
          )}
          {activeSubSubTab === "View Primary" && <PrimaryProjectsComponent />}
          {activeSubSubTab === "Add Primary" && (
            <AddPrimaryComponent changeToView={changeToView} />
          )}
          {activeSubSubTab === "View Separates" && <SeparatesComponent />}
          {activeSubSubTab === "Add Separate" && (
            <AddSeparateComponent changeToView={changeToView} />
          )}
          {activeSubSubTab === "View Resale" && (
            <ResalesComponent pending={false} />
          )}
          {activeSubSubTab === "Pending Resale" && (
            <ResalesComponent pending={true} />
          )}
          {activeSubSubTab === "Add Resale" && (
            <AddResaleComponent changeToView={changeToView} />
          )}
          {activeSubSubTab === "Team Members" && (
            <HelpTeamComponent isSuper={isSuper} />
          )}
          {activeSubSubTab === "Add Member" && (
            <AddHelpTeam isSuper={isSuper} />
          )}
          {activeSubTab === "System" && <System />}
          {activeSubTab === "Forgot password" && <ForgotPasswordPage />}
          {activeSubSubTab === "New feedback" && (
            <FeedbackComponent done={false} />
          )}
          {activeSubSubTab === "Done feedback" && (
            <FeedbackComponent done={true} />
          )}
          {activeSubTab === "Change my password" && <ChangePassword />}
          {activeSubSubTab === "Add Franchise" && (
            <AddFranchise isSuper={isSuper} />
          )}
          {activeSubSubTab === "App Franchises" && (
            <OurFranchiseComponent isSuper={isSuper} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
